import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AppSettings from "../utils/appSettings";
import userManager from "../components/auth/OIDCAuthHandler";
import Loading from "../components/common/Loading";
import { AuthCommandFacade } from "../components/auth/AuthCommandFacade";
import useTokenExpiryCheck from "../hooks/useTokenExpiryCheck";

export const TokenHandler = () => {
  useTokenExpiryCheck();
  const location = useLocation();
  const navigate = useHistory();
  const dispatch = useDispatch();

  const lang = useSelector((state) =>
    state.ui ? state.ui.lang : localStorage.BLLANG,
  );
  const currentUser = useSelector((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);

  const auth = new AuthCommandFacade(dispatch, navigate, lang, currentUser);
  const token = localStorage.getItem("token");
  const code = new URLSearchParams(location.search).get("code");

  useEffect(() => {
    const validateToken = () => {
      if (!token && code) {
        userManager
          .signinRedirectCallback()
          .then(({ access_token }) => {
            auth.login(access_token, location.pathname)
            setIsLoading(false)
          })
          .catch(() => {
            setIsLoading(false)
          })
      } else if (!token && !code) {
        userManager.signinRedirect().catch(() => {
          setIsLoading(false)
        })
      } else if (token) {
        const isValid = auth.isTokenValid(token)
        if (!isValid) {
          auth.logout()
          redirectToIdentityLogout()
        } else {
          auth.login(token, location.pathname)
          setIsLoading(false)
        }
      }
    };
    validateToken();
  }, []);

  const redirectToIdentityLogout = () => {
    const url = AppSettings.identityServer;
    const clientId = AppSettings.clientId;
    const logoutUrl = `${url}/account/logout?clientid=${clientId}&returnurl=${window.location.origin}`;
    window.location.replace(logoutUrl);
  };

  if (isLoading) return <Loading />;

  return <Loading />;
};
